<template>
  <div>
    <CrudList
      title="Review"
      storeName="Reviews"
      :parentStoreName="'Users/'+$route.params.user_id+'/Spots'"
      labelAddNew="Agregar"
      parentUrlKey="spot_id"
      :canAdd="false"
      :canEdit="false"
      labelBack="Atrás"
      sortable
    >

    <template v-slot:short_user="{ item }">
      <v-row align="center" justify="center">
        <v-col cols="12" v-if="item.short_user">
          {{ item.short_user.name }} {{ item.short_user.last_name }}
        </v-col>
      </v-row>
    </template>
    <template v-slot:tags="{ item }">
      <v-row align="center" justify="center">
        <v-col cols="12" v-if="item.tags && item.tags.length > 0">
          <div v-for="(tag, index) in item.tags" :key="index">
            {{ tag.name }}
          </div>
        </v-col>
        <v-col cols="12" v-else>
          
        </v-col>
      </v-row>
    </template>

    </CrudList>
    
  </div>
</template>

<script>
  import CrudList from "@/components/Crud/CrudList";
  import CrudFormMixin from "@/mixins/crud_form";
  export default {
    mixins: [CrudFormMixin],
    components: {CrudList},
    data: () => ({
      offsetTop: 0,
    }),
    methods: {
      onScroll (e) {
        this.offsetTop = e.target.scrollTop
      },
    },
  };
</script>
